import { styled } from "@mui/material";

export const Root = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
}));

export const ValueContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));
